import React from 'react'
import { Route, Routes } from 'react-router-dom'

import Login from './Login/Login'
import ProductDetails from './ProductDetails/ProductDetails'
import Payment from "../Pages/Checkout/payment";
import Pay from "../Pages/Payment/pay";
import Home from '../Components/Home'
import Products from '../Components/Products'
import Cart from './Cart/Cart';
import AddProduct from './Admin/AddProduct'
import AdminHome from './Admin/AdminHome'
import AllUser from './Admin/AllUser'

import FaceMakeup from './Admin/FaceMakeup'
import FaceWash from './Admin/FaceWash'
import HairProduct from './Admin/HairProduct'
import UserDetails from './Admin/UserDetails'
import UserProfile from './UserProfile/UserProfile';
import UserAuth from '../Auth/UserAuth';
import AdminAuth from '../Auth/AdminAuth';
const AllRoutes = () => {
  return (
    <>
    
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/cart' element={<UserAuth><Cart/></UserAuth>}/>
        <Route path="/payment" element={<UserAuth><Pay/></UserAuth>} />
        <Route path="/shipping" element={<UserAuth><Payment /></UserAuth> } />
        <Route path='/product/primer' element={<Products/>}/>
        <Route path='/userProfile' element={<UserAuth><UserProfile/></UserAuth>}/>
        <Route path='/product/singlePage/:id' element={<ProductDetails/>}/>



        <Route path='/admin/home' element={<AdminAuth><AdminHome/></AdminAuth>}/>
        <Route path='/admin/faceMakeup' element={<AdminAuth><FaceMakeup/></AdminAuth>}/>
        <Route path='/admin/hairProduct' element={<AdminAuth><HairProduct/></AdminAuth>}/>
        <Route path='/admin/addProduct' element={<AdminAuth><AddProduct/></AdminAuth>}/>
        <Route path='/admin/allUser' element={<AdminAuth><AllUser/></AdminAuth>}/>
        <Route path='/admin/singleUser/:id' element={<AdminAuth><UserDetails/></AdminAuth>} />

      </Routes>
    </>
  )
}

export default AllRoutes